var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 17,
    viewBox: "0 0 60 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5829)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_100_5829",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 52,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.59 5.0498H4.41V16.7274H55.59V5.0498Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_100_5829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6653 16.7275C16.1217 16.7275 5.52744 8.5728 5.08388 8.24013C4.31618 7.6345 4.1797 6.51707 4.78533 5.74937C5.39096 4.98167 6.50839 4.8196 7.27609 5.42523C7.38698 5.49347 17.3671 13.1705 30.6653 13.1705C43.9636 13.1705 52.5448 5.5873 52.6301 5.502C53.3637 4.84519 54.4811 4.91343 55.1379 5.64701C55.7947 6.38059 55.7265 7.49802 54.9929 8.15483C54.6005 8.51309 45.2772 16.7189 30.6568 16.7189V16.736L30.6653 16.7275Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7205 10.927C58.567 10.927 58.4134 10.9014 58.2599 10.8417C54.3958 9.36601 51.9392 5.59575 52.1524 1.46723V1.21133C52.1951 0.503344 52.7751 -0.0340462 53.5087 7.37518e-05C54.2167 0.0341937 54.7541 0.631294 54.7199 1.33928V1.59518C54.5579 4.6148 56.3577 7.36999 59.1811 8.4533C59.8379 8.7092 60.1706 9.44278 59.9147 10.1081C59.7185 10.6199 59.2323 10.927 58.7205 10.927Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2795 10.927C0.7677 10.927 0.28149 10.6114 0.0852999 10.1081C-0.1706 9.45129 0.16207 8.70918 0.81888 8.45328C3.64231 7.36997 5.44214 4.61478 5.2886 1.59516V1.33926C5.24595 0.639801 5.79187 0.0341715 6.49133 5.14811e-05C7.23344 -0.0340685 7.79642 0.511851 7.83054 1.21131V1.46721C8.05232 5.59573 5.59568 9.36599 1.73159 10.8417C1.57805 10.9014 1.42451 10.927 1.27097 10.927H1.2795Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 16.7273,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth5);
export default __webpack_public_path__ + "static/media/mouth-5.52089a04184ab2ece03d34bdf5dbe4cd.svg";
export { ForwardRef as ReactComponent };